
export interface IProductType {
    id: number,
    name: string;
}

export interface IColumn {
    id: string;
    name: string;
    items : ICard[];
}

export interface ICard {
    id: string;
    name?:string;
    productType?:number;
    productTypeColor?: string;
    serialNo?: number;
    date?: number;
    warranty: boolean;
    hireUnit:boolean;
    urgent: boolean;
    notes: boolean;
    timeElapsed?: boolean;
    timeElapsedColor?: string;
    columnId?: string;
}

export enum Legend {
    warranty=1,
    hireUnit,
    urgent,
    notes
}


export enum ActionType {
    create=1,
    update,
    legendUpdate,
    dragDrop,
    timeElapsedUpdate
}

export enum UpdateType{
    fulldashboard=1,
    itemUpdate
}

export interface IUpdateResponse {
    message : string ,
    data :{
        items:[],
        itemId: number,
        actionType: ActionType,
        updateType: UpdateType
    }
}


export enum NotificationType {
    success="success",
    error="error"
}